import React, { useEffect, useState, useRef } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Box, Typography, Card, CardMedia, IconButton } from "@mui/material";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation } from "react-router-dom";
import { UsePictures } from "./UsePictures";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function ImagesPNG(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [oneFile900, setOneFile900] = useState();
  const location = useLocation();
  const [image, setImage] = React.useState();
  const timer = useRef();
  const { getPictureByID, deletePicture, resize2 } = UsePictures();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    getPictureByID(location.state.id, (pictureRes) => {
      setImage(pictureRes);
    });
  }, []);

  const [stateUp, setStateUp] = React.useState({
    productID: props.model.productID,
    imageJPG: [],
    image360: [],
    imagePng: [],
  });

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const handleChangeImage1 = (file, index) => {
    setOneFile900(file[0]);
    var temp = { index: index };
    var temp2 = [];
    temp2.push(temp);
    setStateUp({ ...stateUp, imagePng: temp2 });
  };

  useEffect(() => {
    if (oneFile900) {
      setProgress(true);
      resize2(
        oneFile900,
        URL.createObjectURL(oneFile900),
        stateUp,
        (callback) => {
          getPictureByID(location.state.id, (pictureRes) => {
            setImage(pictureRes);
          });
        }
      );
    }
  }, [oneFile900]);

  return (
    <Stack>
      <Typography
        color="secondary"
        sx={{ mx: 3, mt: 3, fontWeight: "bold" }}
        variant="h6"
      >
        عکس های PNG :
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(8, 1fr)",
          gap: 2,
          mt: 1,
        }}
      >
        {image &&
          image.imagePng &&
          [1, 2, 3, 4, 5].map((index, i) => {
            let url = image.imagePng.find((model) => model.index == index)
              ? image.imagePng.find((model) => model.index == index).image
              : "/static/img/no-photos.png";

            return (
              <Box
                gridColumn={isSmall ? "span 2" : "span 1"}
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <FileUploader
                  multiple={true}
                  handleChange={(evt) => handleChangeImage1(evt, index)}
                  name="file"
                  types={fileTypes}
                  children={
                    <Box>
                      <Card
                        sx={{
                          p: 2,
                          maxWidth: "150px",
                          maxHeight: "150px",
                          border: "2px dashed #0073E7",
                          borderRadius: 4,
                          boxShadow: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <CardMedia
                          component="img"
                          sx={{ width: "100%", height: "100%" }}
                          image={url}
                        />
                      </Card>
                    </Box>
                  }
                />
                {image.imagePng.find((model) => model.index == index) && (
                  <IconButton
                    type={"عکس"}
                    onClick={() => {
                      setProgress(true);
                      deletePicture(
                        [
                          image.imagePng.find((model) => model.index == index)
                            .id,
                        ],
                        () => {
                          getPictureByID(location.state.id, (pictureRes) => {
                            setImage(pictureRes);
                          });
                        }
                      );
                    }}
                    sx={{ m: "auto", display: "flex" }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            );
          })}
      </Box>
    </Stack>
  );
}
